// This enum is for Medium Attachment GQL endpoint
export enum FileType {
  IMAGE = 'Image',
  VIDEO = 'Video',
  AUDIO = 'Audio',
  DOCUMENT = 'Document',
}
